import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import 'react';

const SmallTrash = ({ testId, className, solid })=>{
    return /*#__PURE__*/ jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        "data-testid": testId,
        className: className,
        children: solid ? /*#__PURE__*/ jsxs(Fragment, {
            children: [
                /*#__PURE__*/ jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M2.65312 2.95905C2.26653 2.95905 1.95312 3.27245 1.95312 3.65905V11.1043C1.95312 12.54 3.12244 13.7 4.55535 13.7H9.43535C10.8703 13.7 12.0376 12.5293 12.0376 11.1043V3.65905C12.0376 3.27245 11.7242 2.95905 11.3376 2.95905H2.65312ZM4.9043 5.6319H6.3043V11.0272H4.9043V5.6319ZM9.0958 5.6319H7.6958V11.0272H9.0958V5.6319Z",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M13 4.29044H1V2.89044H13V4.29044Z",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M7.00018 1.69999C6.78012 1.69999 6.56437 1.7423 6.35789 1.82325C6.1555 1.90259 5.98199 2.01455 5.8431 2.15415L5.83292 2.16418C5.67914 2.31257 5.56426 2.48228 5.48534 2.66973C5.40406 2.8628 5.3624 3.06235 5.3624 3.26446C5.3624 3.65106 5.049 3.96446 4.6624 3.96446C4.2758 3.96446 3.9624 3.65106 3.9624 3.26446C3.9624 2.86613 4.04519 2.48242 4.19502 2.12652C4.34633 1.76712 4.56751 1.44105 4.85568 1.16167C5.1424 0.874978 5.48258 0.662657 5.84692 0.519827C6.20933 0.377756 6.59802 0.299988 7.00018 0.299988C7.80148 0.299988 8.57483 0.609173 9.14465 1.17025C9.70787 1.72484 10.038 2.47689 10.038 3.27303C10.038 3.65963 9.72456 3.97303 9.33796 3.97303C8.95136 3.97303 8.63796 3.65963 8.63796 3.27303C8.63796 2.86833 8.47027 2.47099 8.16238 2.16782C7.86108 1.87114 7.44332 1.69999 7.00018 1.69999Z",
                    fill: "currentColor"
                })
            ]
        }) : /*#__PURE__*/ jsxs(Fragment, {
            children: [
                /*#__PURE__*/ jsx("path", {
                    d: "M2.65308 3.65906V11.1044C2.65308 12.1508 3.50641 13 4.5553 13H9.4353C10.4842 13 11.3375 12.1422 11.3375 11.1044V3.65906",
                    stroke: "currentColor",
                    strokeWidth: "1.4",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M1 3.59039H13",
                    stroke: "currentColor",
                    strokeWidth: "1.4",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M4.66235 3.26447C4.66235 2.96426 4.72458 2.67262 4.84013 2.39814C4.95569 2.12366 5.12458 1.87491 5.3468 1.66047C5.56013 1.44603 5.81791 1.28306 6.10235 1.17155C6.3868 1.06004 6.68902 1 7.00013 1C7.62235 1 8.21791 1.24017 8.65346 1.66905C9.08902 2.09792 9.33791 2.67262 9.33791 3.27305",
                    stroke: "currentColor",
                    strokeWidth: "1.4",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M5.60425 5.6319V11.0272",
                    stroke: "currentColor",
                    strokeWidth: "1.4"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M8.39575 5.6319V11.0272",
                    stroke: "currentColor",
                    strokeWidth: "1.4"
                })
            ]
        })
    });
};

export { SmallTrash as default };
